import React, { useState, useMemo } from 'react';
import { useInterval } from '../../../hooks/useInterval.es.js';
import styled from '@emotion/styled';
import { calculateTimeDelta } from '../Countdown/Countdown.es.js';

const addPaddingNumber = (number) => number.toString().padStart(2, '0');
const daysString = (days) => (days === 0 ? `` : `${days} ngày`);
const BoldWrapper = styled.span `
  font-weight: bold;
`;
const CountdownText = ({ date, className, }) => {
    const [duration, setDuration] = useState(calculateTimeDelta(date));
    useInterval(() => {
        setDuration(calculateTimeDelta(date));
    }, 1000, duration.durationInMs === 0);
    const message = useMemo(() => {
        if (daysString(duration.days) !== ``) {
            return (React.createElement("span", null,
                "C\u00F2n ",
                React.createElement(BoldWrapper, null, daysString(duration.days))));
        }
        else {
            return (React.createElement("span", null,
                'Còn ',
                React.createElement(BoldWrapper, null,
                    addPaddingNumber(duration.hours),
                    ":",
                    addPaddingNumber(duration.minutes),
                    ":",
                    addPaddingNumber(duration.seconds))));
        }
    }, [duration]);
    return React.createElement("span", { className: className }, message);
};

export { CountdownText };
